import {useCallback, useState} from 'react'

export const useExpandedPanels = (initialItemCount: number) => {
  const [expandedPanels, setExpandedPanels] = useState<Set<number>>(() => {
    return initialItemCount === 1 ? new Set([0]) : new Set()
  })

  const togglePanel = useCallback((index: number) => {
    setExpandedPanels((prev) => {
      const next = new Set(prev)
      if (next.has(index)) {
        next.delete(index)
      } else {
        next.add(index)
      }
      return next
    })
  }, [])

  const expandPanel = useCallback((index: number) => {
    setExpandedPanels(new Set([index]))
  }, [])

  const removePanel = useCallback((index: number) => {
    setExpandedPanels((prev) => {
      const next = new Set<number>()
      for (const i of prev) {
        if (i < index) next.add(i)
        else if (i > index) next.add(i - 1)
      }
      return next
    })
  }, [])

  return {expandedPanels, togglePanel, expandPanel, removePanel}
}
